<template>
  <div class="layout-wrapper">
    <!-- 顶部导航条 -->
    <Navbar 
      @show-menu="showMenu = true"
      @show-user="showUser = true" />
    <!-- 左侧菜单 -->
    <Sidebar v-model="showMenu" />
    <!-- 右侧用户 -->
    <User v-model="showUser" />
    <router-view 
      v-if="layoutAlive"
      class="app-main" />

    <!-- 操作日志 -->
    <LogRecord />
  </div>
</template>

<script>
import Navbar from './Navbar.vue'
import Sidebar from './Sidebar'
import User from './User'
import LogRecord from '@/components/LogRecord'
import { mapGetters } from "vuex";
export default {
  data () {
    return {
      showMenu: false,
      showUser: false
    }
  },
  computed: {
    ...mapGetters(['layoutAlive'])
  },
  components: {
    Navbar,
    Sidebar,
    User,
    LogRecord
  }
}
</script>

<style lang="scss" scoped>
.layout-wrapper{
  width: 100%;
  height: 100%;
}
.app-main{
  min-height: calc(100vh - 4.375rem);
  margin-top: 4.375rem;
  overflow: hidden;
  background-color: #F0F2F5;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue